var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.622,
    height: 60.722,
    viewBox: "0 0 60.622 60.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2474",
    "data-name": "Rectangle 2474",
    width: 60.622,
    height: 60.722,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3280",
    "data-name": "Group 3280",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M60.622,12.515a5.292,5.292,0,0,0-5.287-5.286H51.609V3.658A3.662,3.662,0,0,0,47.949,0H47.11a3.662,3.662,0,0,0-3.659,3.658V7.229H17.17V3.658A3.662,3.662,0,0,0,13.511,0h-.84A3.662,3.662,0,0,0,9.013,3.658V7.229H5.286A5.291,5.291,0,0,0,0,12.515v7.208a5.253,5.253,0,0,0,1.741,3.894A4.681,4.681,0,0,0,0,27.243V56.015a4.714,4.714,0,0,0,4.708,4.708h51.2a4.714,4.714,0,0,0,4.708-4.708V27.243a4.684,4.684,0,0,0-1.741-3.626,5.253,5.253,0,0,0,1.741-3.894ZM45.65,9.428V3.658A1.462,1.462,0,0,1,47.11,2.2h.839a1.461,1.461,0,0,1,1.46,1.459v9.693a1.461,1.461,0,0,1-1.46,1.46H47.11a1.462,1.462,0,0,1-1.46-1.46Zm-34.438,0V3.658A1.461,1.461,0,0,1,12.671,2.2h.84a1.461,1.461,0,0,1,1.46,1.459v9.693a1.461,1.461,0,0,1-1.46,1.46h-.84a1.461,1.461,0,0,1-1.459-1.46Zm.871,49.1H4.708a2.512,2.512,0,0,1-2.51-2.51V51h9.884Zm0-8.623H2.2V42.018h9.884Zm0-8.982H2.2V33.037h9.884Zm0-8.981H2.2v-4.7a2.506,2.506,0,0,1,1.825-2.4,5.246,5.246,0,0,0,1.263.169h6.8Zm11.67,26.586H13.182V51H23.754Zm0-8.623H13.182V42.018H23.754Zm0-8.982H13.182V33.037H23.754Zm0-8.981H13.182V25.009H23.754ZM35.425,58.524H24.853V51H35.425Zm0-8.623H24.853V42.018H35.425Zm0-8.982H24.853V33.037H35.425Zm0-8.981H24.853V25.009H35.425ZM47.1,58.524H36.524V51H47.1Zm0-8.623H36.524V42.018H47.1Zm0-8.982H36.524V33.037H47.1Zm0-8.981H36.524V25.009H47.1ZM58.423,56.015a2.512,2.512,0,0,1-2.51,2.51H48.195V51H58.423Zm0-6.113H48.195V42.018H58.423Zm0-8.982H48.195V33.037H58.423Zm0-8.981H48.195v-6.93h7.14a5.236,5.236,0,0,0,1.262-.169,2.506,2.506,0,0,1,1.826,2.4Zm0-12.215a3.11,3.11,0,0,1-3.088,3.087H5.286A3.109,3.109,0,0,1,2.2,19.723V12.515A3.09,3.09,0,0,1,5.286,9.428H9.013v3.922a3.663,3.663,0,0,0,3.658,3.659h.84a3.663,3.663,0,0,0,3.659-3.659V9.428H43.451v3.922A3.663,3.663,0,0,0,47.11,17.01h.839a3.663,3.663,0,0,0,3.659-3.659V9.428h3.727a3.09,3.09,0,0,1,3.088,3.087Z",
    transform: "translate(0 0)",
    fill: "#1a304c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCalendarIcon);
export default __webpack_public_path__ + "static/media/blueCalendarIcon.a71c44b4a43854600c9537c57975ee9e.svg";
export { ForwardRef as ReactComponent };